
import React from "react";
import { Control } from "react-hook-form";
import { FormField, FormItem, FormControl, FormLabel, FormMessage } from "@/components/ui/form";
import { Checkbox } from "@/components/ui/checkbox";
import { Link } from "react-router-dom";

interface Link {
  text: string;
  href: string;
}

interface LinkableCheckboxProps {
  control: Control<any>;
  name: string;
  links?: Link[];
  label: string;
  className?: string;
  joinText?: string;
}

const LinkableCheckbox: React.FC<LinkableCheckboxProps> = ({ 
  control, 
  name, 
  links = [], 
  label,
  className = "",
  joinText = "and"
}) => {
  const renderLabel = () => {
    if (links.length === 0) return label;

    return (
      <>
        {label}{" "}
        {links.map((link, index) => (
          <React.Fragment key={link.href}>
            <Link to={link.href} className="text-grandpal-green hover:underline">
              {link.text}
            </Link>
            {index < links.length - 1 && ` ${joinText} `}
          </React.Fragment>
        ))}
      </>
    );
  };

  return (
    <FormField 
      control={control} 
      name={name} 
      render={({ field }) => (
        <FormItem className={`flex flex-row items-start space-x-3 space-y-0 ${className}`}>
          <FormControl>
            <Checkbox 
              checked={field.value} 
              onCheckedChange={field.onChange} 
            />
          </FormControl>
          <div className="space-y-1 leading-none">
            <FormLabel className="text-sm font-normal">
              {renderLabel()}
            </FormLabel>
            <FormMessage />
          </div>
        </FormItem>
      )} 
    />
  );
};

export default LinkableCheckbox;
